<script>
    export let frontend_endpoint;
    export let backend_endpoint;
    export let token;
    export let username;
    export let roles;
    $: context = {
        frontend_endpoint,
        backend_endpoint,
        token,
        username,
        roles,
    };

    let items;
    let selectedItem;

    import { onMount } from "svelte";
    import { fetchWithAuthentication } from "./api/client.js";
    import FilenameSelector from "./components/FilenameSelector.svelte";

    async function getCollections() {
        const response = await fetchWithAuthentication(
            context,
            "/get_all_data_with_tags_versions/",
            {}
        );
        items = response.versions;
        // selectedItem = { value: items[0][0], label: items[0][1] };
    }

    onMount(() => {
        getCollections();
    });
</script>

<form
    class="move-form themed"
    action="/admin/approvedrequest/move"
    method="post"
>
    <FilenameSelector
        label="ย้ายข้อมูลไป:"
        id="move_to"
        {items}
        bind:value={selectedItem}
        containerStyles="min-width: 300px;"
        size={7}
    >
        <div class="col-sm-2">
            <button class="btn btn-primary" disabled={!selectedItem}
                >ย้ายข้อมูล</button
            >
        </div>
    </FilenameSelector>

    <input
        type="hidden"
        name="collection_name"
        value={selectedItem && selectedItem.value}
    />
</form>

<style>
    .move-form {
        margin: 0;
        width: 100%;
    }
    .themed {
        --height: 33px;
    }
</style>
